import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import BreadCrumb from '../../../../core/layout/Breadcrumb';
import Card from '../../../../core/layout/Card';
import Row from '../../../../core/layout/Row';
import Column from '../../../../core/layout/Column';
import Separator from '../../../../core/layout/Separator';
import StudentAccessFrequencyDetailTableContainer from './student/StudentAccessFrequencyDetailTableContainer';
import StudentEngagementDetailTableContainer from './student/StudentEngagementDetailTableContainer';
import StudentChurnDetailTableContainer from './student/StudentChurnDetailTableContainer';
import StudentStudyQualityDetailTableContainer from './student/StudentStudyQualityDetailTableContainer';
import PartnerLicensePackageUsageRateDetailTableContainer from './partner/PartnerLicensePackageUsageRateDetailTableContainer';
import PartnerStudentVariationDetailTableContainer from './partner/PartnerStudentVariationDetailTableContainer';
import PartnerAccessFrequencyDetailTableContainer from './partner/PartnerAccessFrequencyDetailTableContainer';
import CustomerSuccessSummary from './CustomerSuccessSummary';
import { browserHistory } from 'react-router';
import Button from '../../../../core/form/Button';
import KpiReferenceMonth from '../../commons/KpiReferenceMonth';

const CustomerSuccessDetailScene = (props) => {
  const typeName = get(props.segment, 'name') || get(props.distributor, 'name', 'N/A');

  return (
    <div>
      <BreadCrumb
        fetching={props.isLoading}
        crumbs={[
          {
            text: "KPI's Customer Success",
            link: `/kpis/customer-success`,
          },
          {
            text: typeName,
          },
        ]}
      />
      <Card actions={<Button icon="arrow-left" label="back" onClick={() => browserHistory.goBack()} />}>
        <KpiReferenceMonth />
      </Card>
      <Separator />
      <Card title={`Summary - ${typeName}`}>
        <CustomerSuccessSummary type={props.type} typeId={props.typeId} />
      </Card>
      <Separator />
      <Card title="Partners" collapsible>
        <Row>
          <Column size={6}>
            <PartnerAccessFrequencyDetailTableContainer type={props.type} typeId={props.typeId} />
          </Column>
          <Column size={6}>
            <PartnerLicensePackageUsageRateDetailTableContainer type={props.type} typeId={props.typeId} />
          </Column>
        </Row>
        <Separator />
        <Row>
          <Column size={6}>
            <PartnerStudentVariationDetailTableContainer type={props.type} typeId={props.typeId} />
          </Column>
        </Row>
      </Card>
      <Separator />
      <Card title="Students" collapsible>
        <Row>
          <Column size={6}>
            <StudentAccessFrequencyDetailTableContainer type={props.type} typeId={props.typeId} />
          </Column>
          <Column size={6}>
            <StudentEngagementDetailTableContainer type={props.type} typeId={props.typeId} />
          </Column>
        </Row>
        <Separator />
        <Row>
          <Column size={6}>
            <StudentChurnDetailTableContainer type={props.type} typeId={props.typeId} />
          </Column>
          <Column size={6}>
            <StudentStudyQualityDetailTableContainer type={props.type} typeId={props.typeId} />
          </Column>
        </Row>
      </Card>
    </div>
  );
};

CustomerSuccessDetailScene.propTypes = {
  segment: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  distributor: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  isLoading: PropTypes.bool.isRequired,
};

export default CustomerSuccessDetailScene;
